import React from "react";
import Nav from 'react-bootstrap/Nav';
import { useNavigate } from "react-router-dom";
import { PRODUCTION_PORTAL_PATH } from "../../config/productionRoutes";

function AdminNav() {
    const navigate = useNavigate();
    
    const handleHomeClick = () => {
        navigate(PRODUCTION_PORTAL_PATH);
    };

    return (
        <div className="modern-nav-container">
            <Nav variant="tabs" className="modern-nav admin-nav">
                <Nav.Item>
                    <Nav.Link 
                        onClick={handleHomeClick}
                        className="modern-nav-link home-nav-link"
                    >
                        <i className="bi bi-house-fill me-2"></i>
                        Back to Job List
                    </Nav.Link>
                </Nav.Item>
            </Nav>
        </div>
    );
}

export default AdminNav;
